import FindingCard, { VendorIdentity, OtherAnalytics } from './finding-card'

// Keyed off `transaction.duplicate`, not the analytic's flags: the server only sends
// the compare for findings that have one.
const DuplicateFindingCard = ({ transaction, onOpenReview }) => {
  const duplicate = transaction.duplicate
  const analytics = transaction.analytics || []
  const peers = duplicate.peers || []
  const sectionFields = transaction.section_fields

  // Fallback so a filter that drops the analytic can't cost the card its review.
  const analytic = analytics.find((entry) => entry.id === duplicate.analytic_id) || {
    id: duplicate.analytic_id,
    name: duplicate.analytic_name
  }

  return (
    <FindingCard
      transaction={transaction}
      eyebrow="Possible duplicate"
      onOpen={() => onOpenReview(transaction, analytic, 'duplicate')}
    >
      <div className="monitoring-match">
        <div style={{ minWidth: 0 }}>
          <div className="text-muted small">Vendor</div>
          <VendorIdentity
            name={transaction.vendor_name}
            externalId={transaction.external_id}
            status={sectionFields?.vendor_status}
          />
        </div>
        <span className="monitoring-match-arrow" aria-hidden="true">&#8646;</span>
        <div style={{ minWidth: 0 }}>
          <div className="text-muted small">
            {peers.length > 1 ? `Possible matches (${peers.length})` : 'Possible match'}
          </div>
          {peers.length === 0 && (
            <div className="monitoring-match-name is-empty">No matching record found</div>
          )}
          {peers.map((peer) => (
            <VendorIdentity
              key={peer.id}
              name={peer.vendor_name}
              externalId={peer.external_id}
              status={peer.vendor_status}
            />
          ))}
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap gap-2 mt-3">
        {duplicate.score !== null && duplicate.score !== undefined && (
          <span className="monitoring-match-score">
            <strong>{duplicate.score}%</strong>
            <span>match</span>
          </span>
        )}
        <OtherAnalytics analytics={analytics} exceptIds={[duplicate.analytic_id]} />
      </div>
    </FindingCard>
  )
}

export default DuplicateFindingCard
